export default __webpack_public_path__ + "static/media/borderlands-3.ab8fb396.png";